import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IRootState } from 'src/types/store-types';
import SocialIcons from '../SocialIcons';
import './styles.scss';

type Props = {
  newClass?: string;
  handleClick?: () => void;
  isheaderModal?: boolean;
};

const Footer: FC<Props> = ({ newClass, handleClick, isheaderModal }) => {
  const { t } = useTranslation();
  const { lng } = useSelector((state: IRootState) => state.app);
  const year = new Date().getFullYear();
  const languagePrefix = `/${lng.toLowerCase()}`;

  return (
    <footer className={`footer-container  ${newClass}`}>
      <div className="footer-left-block">
        <Link to={languagePrefix} aria-label="TouRest.online">
          <img src="/images/logo.svg" className="footer-logo" alt="TouRest.online" />
        </Link>
      </div>

      {!isheaderModal && (
        <div className="footer-navigation">
          <Link to={`${languagePrefix}/about`} className="footer-nav" onClick={handleClick}>
            {t('about')}
          </Link>
          <Link to={`${languagePrefix}/privacy`} className="footer-nav" onClick={handleClick}>
            {t('privacyPolicy')}
          </Link>
          <Link className="footer-nav" to={`${languagePrefix}/blog`}>
            {t('blog')}
          </Link>
          <Link className="footer-nav" to={`${languagePrefix}/referrer`}>
            {t('becomePartner')}
          </Link>
          <Link className="footer-nav" to={`${languagePrefix}/rates`}>
            {t('rates')}
          </Link>
        </div>
      )}
      <div className="footer-right-block">
        <SocialIcons className="footer-icon" />
        <p className="footer-text">
          {t('copyright')} &copy; {year}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
